import Color from "@arcgis/core/Color";
import { createMapItem, MapItemPopup, SimpleFillStyle } from "./arcgisUtils";
import { Area } from "./models/Area";
import { Project } from "./models/Project";

const red = new Color([255, 0, 0]);
const green = new Color([119, 226, 40]);
const orange = new Color([226, 119, 40]);

const getColor = (typeKey: string) => {
    switch (typeKey) {
        case "PermitBoundary":
            return orange;
        case "AnnotationBoundary":
            return red;
        default:
            return orange;
    }
};

const getStyle = (typeKey: string): SimpleFillStyle => {
    switch (typeKey) {
        case "PermitBoundary":
            return "solid";
        case "AnnotationBoundary":
            return "backward-diagonal";
        default:
            return "solid";
    }
};

export const createBoundryMapItem = (id: string, withPopup: boolean, boundary: Area) => {
    return createMapItem(
        "polygon",
        boundary.polygon.coordinates as number[][][],
        withPopup
            ? ({
                  id: id,
                  name: "Edit",
                  title: "Type: " + boundary.type?.name,
                  content: "Comment: " + (boundary.comments || ""),
                  hasAction: false,
              } as MapItemPopup)
            : undefined,
        undefined,
        getColor(boundary.type.key),
        getStyle(boundary.type.key)
    );
};

export const createProjectBoundaries = (project: Project) => {
    if (!project.boundaries) {
        return null;
    }

    return createMapItem(
        "polyline",
        project.boundaries.coordinates as number[][][],
        {
            id: project.id,
            name: "View project",
            title: `Project: ${project.name} ${project.number ? "(" + project.number + ")" : ""}`,
            content: "",
            hasAction: false,
        } as MapItemPopup,
        undefined,
        green
    );
};
